import styled from 'styled-components';

export const Content = styled.header`

   #loading, #loading2, #aguarde, #btn-envia-formulario-loading, #btn-alterar-senha-loading{
    display: none
   }

    width: 100%;
    position: relative;
    background: #fff;
    /* border-bottom: 1px solid rgb(221, 221, 221); */
    box-shadow: rgb(0 0 0 / 10%) 0px 0px 15px;
    padding:  0;
    text-align: left;
    height: 65px;

    #perfil{
        font-size: 14px;
        float: right;
        text-align: right;
        padding: 0 2rem;

        span, a{
            color: #333;
            font-weight: 600;
            cursor: pointer;           
        }
    }

    #logo{       
        max-width: 150px;
        float: left;
        padding: 0 1rem;
    }


    .olho2{
        position: relative;
        width: 20px;
        z-index: 2;
        opacity: 0.6;
        cursor: pointer;
        margin: -40px 10px 0 0;
        float: right;
    }
    
    #blacksenha{
		background-color: rgba(0, 0, 0, 0.7);
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: none;
		z-index:10;
	}   

	#close{
		position: absolute;
		top: 10px;
		right: 10px;
		width: 20px;
		cursor: pointer;
		opacity: 0.6;
	}

	#alterasenha{
		background: #fff;
		border-radius: 5px;
		margin: 0 auto;
		padding: 1rem;
		margin-top: 10%;
		width: 95%;
        max-width: 350px;
		position: relative;

        h2{
            width: 100%;
            text-align: center;
            font-size: 20px;
        }

        form div{
            position: relative;
            width: 100%;
            display: block;
        }

        input[type="password"]{
            width: 100%;
            display: block;
            border-radius: 0.25rem;
            border: 1px #ddd solid;
            padding: 1rem;
            margin: 5px 0;
            position: relative;
        }

        input[type="button"], #cad input[type="submit"]{
            width: 100%;
            float:left;
            background:var(--blue);
            border-radius:5px;
            margin:5% 0	;
            padding:4.5%;
            color:#fff;
            border:none;
            font-weight:600;           
            cursor:pointer;
            transition: 0.3s;
            font-size:16px;
        }

	}


	.tip{
		display:none;
		position: relative;
		border-radius: 5px !important;
		padding: 3% 1%;
		width: 100%;
		float: left;

        span{
            float: left;
            width: 50%;
            position: relative;
            padding: 5px 10px;
            font-size: 11px;
        }

        .dng{
            color: #c82c09
        }

        .scs{
            color: #479652
        }

        img{
            float: right;
            width: 12px;
        }

        .closed{
            position: absolute;
            top: -6%;
            right: 0%;
            width: 20px;
            cursor: pointer;
        }
	}

   
 

`

export const Nav = styled.nav`

    width: 100%;
    position: relative;
    border-top: 1px #ddd solid;
    display: inline-block;
    text-align: center;
    padding: 0.50rem 0;
    z-index:2;
    background: rgb(2, 98, 96);

    ul{
        display: inline;
    }

    ul li{
        display: inline-block;
        padding: 0.50rem 1rem;
        position: relative;       
    }

    ul li a{
        color: #fff;
        font-weight: 500;
        
            &:hover{
                opacity: 0.8;
            }
    }

    ul li:hover .submenu{
        visibility: visible;
    }
       

    .submenu{
        visibility: hidden;
        opacity: 1.0;
        width: 250px;
        position: absolute;
        top: 35px; 
        background: #36669c;
        left: -60%;
        box-shadow: rgb(0 0 0 / 10%) 0px 0px 15px;
        border-radius: 0.25rem;
        padding: 0.50rem 0;

        ::after {
            /* border-bottom: 10px solid #36669c; */
            border-left: 8px solid transparent;
            border-right:8px solid transparent;
            content: "";
            position: absolute;
            left: 35%;
            top: 2px;
            transform: translateY(-100%);
            z-index: 4;
        }
        ul{
            padding: 1rem 0;
        }

        li{
            width: 100%;
            display: inline-block;
            padding:  0.50rem 1rem;
            text-align: left;
            border: none;
        }

    }

    #menu-mobile {
        display: none;
        position: absolute;
        top: 30%;
        left: 1.5%;
        width: 40px;
        cursor: pointer;

        span {
            background: #fff;
            width: 100%;
            border-radius: 50px;
            padding: 2px;
            margin: 3px 0;
            float: left;
        }
    }

    
@media only screen and  (max-width: 1025px){
    
    height: 60px;

    ul li {
        font-size: 15px;
        width: 100%;
        text-align: left;
        padding: 1rem;
        border: none;
    }

    #menu-mobile {
        display: block;
    }

      
    #menulogado {
        background: #36669c;
        position: absolute;
        top:97%;
        left: -100%;
        min-height: 100%;
        width: 80%;
        max-width: 500px;
        padding: 2% 1%;
        z-index: 10;
        transition: 1s;
    }

    .mostramenu {
      left: 0!important;
      opacity: 1!important;
      transition: 1s;
    }

}






`


export const BtMostraSenha = styled.a`
  cursor: pointer;
  color: #00ACEC;
  position: absolute;
  right: 10px;
  top: 40px;

  :hover {
    filter: brightness(120%);
  }
`;

export const DivVerificaSenha = styled.div`
    display: none;
    font-family: 'Montserrat',sans-serif;
    position: absolute;
    z-index: 10;
    background: #FFF;
    text-align: left;
    width: fit-content !important;
    border-radius: 6px;
    padding: 10px;
    font-size: 12px;
    box-shadow: 0px 2px 5px rgb(0 0 0 / 20%);
    ${props => props.id === 'Cadastro' ? ` margin-top: 60px; ` : ` margin-top: 0px; `};
    div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ebebeb;
      :last-child {
        border-bottom: none;
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
      svg {
        margin-right: 5px;
      }
    }
    .scs { color: #178113; }
    .dng { color: #ffbf00; }
`;